// extracted by mini-css-extract-plugin
export default {"PageTitle":"ProductProposals_PageTitle__0eYAd"};